import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
// import Datetime from "react-datetime";
import { Calendar } from "primereact/calendar";
import { Button, TextField } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import ReactToPrint from "react-to-print";
// import Barcode from "react-barcode";
import ZebraPrinterWidget from "./Printer";
import PrintDialog from "components/Dialog/PrintDialog";

registerPlugin(
  FilePondPluginFileEncode,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
);

const AddDetailsVariantMaster = (props) => {
  const [userId, setUserId] = useState("");
  const [detailsId, setDetailsId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [variantLength, setVariantLength] = useState(0);
  const [formData, setFormData] = useState({
    skuId: "",
    product: "",
    productErr: false,
    productErrText: "",
    subCategory: "",
    subCategoryErr: false,
    subCategoryErrText: "",
    category: "",
    categoryErr: false,
    categoryErrText: "",
    brand: "",
    brandErr: false,
    brandErrText: "",
    lifeSpan: "",
    lifeSpanErr: false,
    lifeSpanErrText: "",
    hsnCode: "",
    hsnCodeErr: false,
    hsnCodeErrText: "",
    gstRate: "",
    gstRateErr: false,
    gstRateErrText: "",
    barcode: "",
    productDescription: "",
    storageInstructions: "",
    photo: [],
  });

  const [variants, setVariants] = useState([]);
  const [dropdownData, setDropdownData] = useState({
    products: [],
    subCategories: [],
    categories: [],
    brands: [],
    hsnCodes: [],
    gstRates: [],
    units: [],
  });

  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });
  const [printData, setPrintData] = useState({});
  const [templateHtml, setTemplateHtml] = useState("");
  const [printData1, setPrintData1] = useState("");
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const printButtonRef = useRef(null);
  const componentRef = useRef(null);
  const zebraWidgetRef = useRef(null);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.DetailsId) {
      GetDetailsVariantMasterById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
        GetImageConfiguration(data);
      } else {
        GetProductMaster(data);
        GetSubCategoryMaster(data);
        GetCategoryMaster(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetHSNCodeMaster(data);
        GetGSTMaster(data);
      }
    } else {
      generateSkuId(data);
      GetProductMaster(data);
      GetSubCategoryMaster(data);
      GetCategoryMaster(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetHSNCodeMaster(data);
      GetGSTMaster(data);
    }
  }, []);

  useEffect(() => {
    if (templateHtml && printData.Barcode) {
      // const timeout = setTimeout(() => {
      //   [printData].forEach((product, productIdx) => {
      //     [0, 1].forEach((slotIdx) => {
      //       const container = document.getElementById(
      //         `barcode-container-${productIdx}-${slotIdx}`
      //       );
      //       if (container) {
      //         const barcodeElement = document.createElement("div");
      //         container.innerHTML = "";
      //         container.appendChild(barcodeElement);
      //         ReactDOM.render(
      //           <Barcode
      //             value={product.Barcode}
      //             height={60}
      //             width={6}
      //             fontSize={30}
      //           />,
      //           barcodeElement
      //         );
      //       }
      //     });
      //   });
      //   if (printButtonRef?.current) {
      //     printButtonRef.current.click();
      //   }
      // }, 100);
      // return () => clearTimeout(timeout);

      setShowPrintDialog(true);
    }
  }, [templateHtml, printData.Barcode]);

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetProductMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            products: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetSubCategoryMaster = async (UserId) => {
    try {
      let params = {
        UserID: UserId,
      };
      await api
        .post(APIConstant.path.GetSubCategoryMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            setDropdownData((prevState) => ({
              ...prevState,
              subCategories: response.Data,
            }));
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetCategoryMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetCategoryMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            categories: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          setDropdownData((prevState) => ({
            ...prevState,
            hsnCodes: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            }),
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };
  const GetRenderTemplate = async (Data, Type) => {
    try {
      let paramData = {
        UserId: userId,
        PrintData: [Data],
        ConfigurationName: "Manufacturing Barcode",
        Type,
      };
      await api
        .post(APIConstant.path.GetRenderTemplate, paramData)
        .then(async (response) => {
          setTemplateHtml("");
          if (response.Success === 1) {
            setTemplateHtml(response.Html);
            setPrintData1(response.Data);
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const generateSkuId = (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GenerateUniqueSKUId, params)
      .then(async (res) => {
        if (res.Success === 1) {
          setFormData((prev) => ({ ...prev, skuId: res.generatedID }));
        }
      })
      .catch((err) => {});
  };

  const GetDetailsVariantMasterById = async (UserId) => {
    try {
      let params = {
        UserId,
        DetailsId: props.location.state.DetailsId,
      };
      api
        .post(APIConstant.path.GetDetailsVariantMasterById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              SkuId,
              Brand,
              BrandName,
              Category,
              CategoryName,
              GstRate,
              GstName,
              HSNCode,
              HSNCodeName,
              LifeSpan,
              Barcode,
              Product,
              ProductName,
              ProductDescription,
              StorageInstructions,
              Photo,
              SubCategory,
              SubCategoryName,
              Variants,
              _id,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              skuId: SkuId,
              brand: Brand,
              brandName: BrandName,
              category: Category,
              categoryName: CategoryName,
              subCategory: SubCategory,
              subCategoryName: SubCategoryName,
              gstRate: GstRate,
              gstName: GstName,
              hsnCode: HSNCode,
              hsnCodeName: HSNCodeName,
              lifeSpan: LifeSpan,
              product: Product,
              productName: ProductName,
              barcode: Barcode,
              productDescription: ProductDescription,
              storageInstructions: StorageInstructions,
              photo:
                Photo && Photo.filename
                  ? [
                      {
                        source: `${process.env.REACT_APP_API_ENDPOINT}/document/${Photo.filename}`,
                      },
                    ]
                  : [],
            }));
            let newVariants = Variants.map((variant) => ({
              _id: variant._id,
              skuId: variant.SkuId,
              packagingType: variant.PackagingType,
              weightVolume: variant.WeightVolume,
              unit: variant.Unit,
              unitName: variant.UnitName,
              name: variant.Name,
              price: variant.Price,
              mrp: variant.Mrp,
              description: variant.Description,
              barcode: variant.Barcode,
              photos: (variant.Photos || []).map((photo) => ({
                source: `${process.env.REACT_APP_API_ENDPOINT}/document/${photo.filename}`, // replace PORT with actual port (e.g., 5000)
                // options: {
                //   type: "local",
                // },
              })),
              Batches: variant.Batches
                ? variant.Batches.map((batch) => ({
                    _id: batch._id,
                    batchNo: batch.BatchNo,
                    mfgDate: batch.MfgDate,
                    expiryDate: batch.ExpiryDate,
                    mrp: batch.Mrp,
                    rate: batch.Rate,
                    qtyProduced: batch.QtyProduced,
                    qtyRemaining: batch.QtyRemaining,
                    status: batch.Status,
                    barcode: batch.Barcode,
                  }))
                : [],
            }));
            setDetailsId(_id);
            setVariants(newVariants);
            setVariantLength(Variants.length);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  async function convertSourceToFile(sourceUrl, fileName, mimeType) {
    const res = await fetch(sourceUrl);
    const blob = await res.blob();

    return new File([blob], fileName, {
      type: mimeType || blob.type || "image/jpeg",
      lastModified: new Date().getTime(),
    });
  }

  const AddUpdateDetailsVariant = async () => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const formDataToSend = new FormData();

      const payload = {
        Details: {
          ...formData,
          categoryName: dropdownData.categories.find(
            (item) => item.value === formData.category,
          )?.label,
          subCategoryName:
            dropdownData.subCategories.find(
              (item) => item.value === formData.subCategory,
            )?.label || "",
          brandName:
            dropdownData.brands.find((item) => item.value === formData.brand)
              ?.label || "",
          hsnCodeName:
            dropdownData.hsnCodes.find(
              (item) => item.value === formData.hsnCode,
            )?.label || "",
          productName:
            dropdownData.products.find(
              (item) => item.value === formData.product,
            )?.label || "",
          gstName:
            dropdownData.gstRates.find(
              (item) => item.value === formData.gstRate,
            )?.label || "",
        },
        Variants: [],
        UserId: userId,
        DetailsId: detailsId,
      };

      if (formData.photo?.length) {
        const fileMeta = formData.photo[0].file || formData.photo[0];
        if (!(fileMeta instanceof File)) {
          let fileName = "+-test+-" + fileMeta?.name;
          const mimetype = fileMeta?.type || "image/jpeg";
          const file = await convertSourceToFile(
            `${process.env.REACT_APP_API_ENDPOINT}/document/${fileMeta.name}`,
            fileName,
            mimetype,
          );
          formDataToSend.append("productPhoto", file);
        } else {
          formDataToSend.append("productPhoto", fileMeta);
        }
      }

      // 2. Attach files for each variant and strip out file objects
      for (let index = 0; index < variants.length; index++) {
        const variant = variants[index];
        const cleanVariant = { ...variant };
        cleanVariant.unitName =
          dropdownData.units.find((unit) => unit.value === variant.unit)
            ?.label || "";

        cleanVariant.photos = []; // We'll fill this later in the backend
        payload.Variants.push(cleanVariant);

        // Now handle photos synchronously
        const photos = variant.photos || [];
        for (let photoIdx = 0; photoIdx < photos.length; photoIdx++) {
          const fileObj = photos[photoIdx];
          const fileMeta = fileObj.file || fileObj;

          if (!(fileMeta instanceof File)) {
            const fileName = "+-test+-" + fileMeta?.name;
            const mimetype = fileMeta?.type || "image/jpeg";
            const file = await convertSourceToFile(
              `${process.env.REACT_APP_API_ENDPOINT}/document/${fileMeta.name}`,
              fileName,
              mimetype,
            );
            formDataToSend.append(`variantPhoto_${index}_${photoIdx}`, file);
          } else {
            formDataToSend.append(
              `variantPhoto_${index}_${photoIdx}`,
              fileMeta,
            );
          }
        }
      }

      // 3. Attach JSON as a string
      formDataToSend.append("Details", JSON.stringify(payload.Details));
      formDataToSend.append("Variants", JSON.stringify(payload.Variants));
      formDataToSend.append("UserId", payload.UserId);
      if (payload.DetailsId)
        formDataToSend.append("DetailsId", payload.DetailsId);

      const response = await api.post(
        APIConstant.path.AddUpdateDetailsVariantMaster,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setLoading(false);

      if (response.Success === 1) {
        cogoToast.success(response.Message);
        props.history.push("/admin/details-variant-master");
      } else {
        cogoToast.error(response.Message);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const validate = () => {
    let isValid = true;

    // Local copy of formData to validate synchronously
    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "product", label: "Product" },
      { key: "subCategory", label: "Sub Category" },
      { key: "category", label: "Category" },
      { key: "brand", label: "Brand" },
      { key: "lifeSpan", label: "Life Span" },
      { key: "hsnCode", label: "HSN Code" },
      { key: "gstRate", label: "GST Rate" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    // Local copy of variants
    let updatedVariants = [...variants];

    updatedVariants = updatedVariants.map((variant) => {
      const updatedVariant = { ...variant };

      const variantFields = [
        { key: "packagingType", label: "Packaging Type" },
        { key: "weightVolume", label: "Weight/Volume" },
        { key: "unit", label: "Unit" },
        { key: "name", label: "Variant Name" },
      ];

      variantFields.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(variant[key])) {
          if (key === "weightVolume" && variant.packagingType === "Loose") {
          } else {
            isValid = false;
            updatedVariant[`${key}Err`] = true;
            updatedVariant[`${key}ErrText`] = `${label} is required`;
          }
        } else {
          updatedVariant[`${key}Err`] = false;
          updatedVariant[`${key}ErrText`] = "";
        }
      });

      // Validate Batches
      updatedVariant.Batches = variant.Batches.map((batch) => {
        const updatedBatch = { ...batch };

        const batchFields = [
          { key: "batchNo", label: "Batch No" },
          { key: "mfgDate", label: "MFG Date" },
          { key: "expiryDate", label: "Expiry Date" },
          { key: "mrp", label: "MRP" },
          { key: "rate", label: "Rate" },
        ];

        batchFields.forEach(({ key, label }) => {
          if (CommonConfig.isEmpty(batch[key])) {
            isValid = false;
            updatedBatch[`${key}Err`] = true;
            updatedBatch[`${key}ErrText`] = `${label} is required`;
          } else {
            updatedBatch[`${key}Err`] = false;
            updatedBatch[`${key}ErrText`] = "";
          }
        });

        return updatedBatch;
      });

      return updatedVariant;
    });

    setVariants(updatedVariants);

    if (!variants.length) {
      isValid = false;
      cogoToast.error("Please add a variant");
    }

    return isValid;
  };

  const handleFormChange = (value, field, regex) => {
    if (!value) {
      if (field === "lifeSpan") {
        let tempVariants = [...variants];
        variants.forEach((variant) => {
          variant.Batches.forEach((batch) => {
            batch.expiryDate = "";
          });
        });
        setVariants(tempVariants);
      }
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        if (field === "hsnCode") {
          extraObj.gstRate = dropdownData.hsnCodes.find(
            (item) => item.value === value,
          )?.GST;
        } else if (field === "subCategory") {
          extraObj.category = dropdownData.subCategories.find(
            (item) => item.value === value,
          )?.Category;
        } else if (field === "lifeSpan") {
          let tempVariants = [...variants];
          variants.forEach((variant, varIdx) => {
            variant.Batches.forEach((batch, batchIdx) => {
              if (batch.mfgDate) {
                batch.expiryDate = moment(batch.mfgDate)
                  .add(parseInt(value), "days")
                  .toDate();
              }
            });
          });
          setVariants(tempVariants);
        }
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const addVariant = () => {
    setVariantLength((prev) => prev + 1);
    setVariants((prev) => [
      ...prev,
      {
        skuId: `${formData.skuId}/${(variantLength + 1)
          .toString()
          .padStart(2, "0")}`,
        packagingType: "",
        packagingTypeErr: false,
        packagingTypeErrText: "",
        weightVolume: "",
        weightVolumeErr: false,
        weightVolumeErrText: "",
        unit: "",
        unitErr: false,
        unitErrText: "",
        name: "",
        nameErr: false,
        nameErrText: "",
        price: "",
        mrp: "",
        photos: [],
        description: "",
        Batches: [],
      },
    ]);
  };

  const removeVariant = (index) => {
    setVariants((prev) => prev.filter((_, i) => i !== index));
  };

  const addBatch = (variantIndex) => {
    let tempDate = new Date();

    setVariants((prev) => {
      const updated = [...prev];
      updated[variantIndex].Batches.push({
        batchNo: "",
        batchNoErr: false,
        batchNoErrText: "",
        mfgDate: tempDate,
        mfgDateErr: false,
        mfgDateErrText: "",
        expiryDate: formData.lifeSpan
          ? moment(tempDate)
              .add(parseInt(formData.lifeSpan), "days")
              .toDate()
          : "",
        mrp: "",
        mrpErr: false,
        mrpErrText: "",
        rate: "",
        rateErr: false,
        rateErrText: "",
        qtyProduced: 0,
        qtyRemaining: 0,
        status: "Active",
        barcode: "",
      });
      return updated;
    });
  };

  const removeBatch = (variantIndex, batchIndex) => {
    setVariants((prev) => {
      const updated = [...prev];
      updated[variantIndex].Batches.splice(batchIndex, 1);
      return updated;
    });
  };

  const handleOpen = async (data, type, printType) => {
    if (type === "Print") {
      let tempPrice = data.mrp || data.rate;
      if (printType === "Variant") {
        let tempData = {
          PrintType: printType,
          ProductId: data._id,
          Name: data.name,
          Mrp: data.mrp,
          Rate: data.price,
          Weight:
            data.packagingType === "Fixed"
              ? `${data.weightVolume || ""} ${data.unitName}`
              : "",
          Unit: data.packagingType === "Loose" ? `${data.unitName}` : "",
          USP:
            data.unitName && tempPrice
              ? data.weightVolume
                ? `${(tempPrice / data.weightVolume).toFixed(2)}/${
                    data.unitName
                  }`
                : `${tempPrice.toFixed(2)}/${data.unitName}`
              : "",
          Barcode: data.barcode,
        };
        setPrintData(tempData);
        await GetRenderTemplate(tempData, "Variant Template");
      } else {
        let tempData = {
          PrintType: printType,
          ProductId: data._id,
          Name: data.Variant?.name,
          Weight:
            data.Variant?.packagingType === "Fixed"
              ? `${data.Variant?.weightVolume || ""} ${data.Variant?.unitName}`
              : "",
          Unit:
            data.Variant?.packagingType === "Loose"
              ? `${data.Variant?.unitName}`
              : "",
          USP:
            data.Variant?.unitName && tempPrice
              ? data.Variant?.weightVolume
                ? `${(tempPrice / data.Variant?.weightVolume).toFixed(2)}/${
                    data.Variant?.unitName
                  }`
                : `${tempPrice.toFixed(2)}/${data.Variant?.unitName}`
              : "",
          BatchNo: data.batchNo,
          MfgDate: data.mfgDate,
          ExpiryDate: data.expiryDate,
          Rate: data.rate,
          Mrp: data.mrp,
          Barcode: data.barcode,
        };
        setPrintData(tempData);
        await GetRenderTemplate(tempData, "Variant Template");
      }
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/details-variant-master");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Details & Variant Master</h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Sku Id</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.skuId}</p>
                  ) : (
                    <InputText
                      // autoFocus
                      value={formData.skuId}
                      disabled
                      placeholder="SKU Id"
                      className="p-w-100 e-input-common "
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Product Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.productName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          // autoFocus
                          filter
                          options={dropdownData.products}
                          value={formData.product}
                          onChange={(e) => handleFormChange(e.value, "product")}
                          placeholder="Product Name"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.productErr ? formData.productErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Sub Category</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.subCategoryName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.subCategories}
                          value={formData.subCategory}
                          onChange={(e) =>
                            handleFormChange(e.value, "subCategory")
                          }
                          placeholder="Sub Category"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.subCategoryErr
                          ? formData.subCategoryErrText
                          : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Category</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.categoryName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.categories}
                          value={formData.category}
                          onChange={(e) =>
                            handleFormChange(e.value, "category")
                          }
                          placeholder="Category"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.categoryErr ? formData.categoryErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Brand Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.brandName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.brands}
                          value={formData.brand}
                          onChange={(e) => handleFormChange(e.value, "brand")}
                          placeholder="Brand Name"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.brandErr ? formData.brandErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Life Span (Days)</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.lifeSpan}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.lifeSpan}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "lifeSpan",
                              /^\d*$/i,
                            )
                          }
                          maxLength={5}
                          placeholder="Life Span"
                          className="p-w-100 e-input-common "
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.lifeSpanErr ? formData.lifeSpanErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">HSN Code</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.hsnCodeName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.hsnCodes}
                          value={formData.hsnCode}
                          onChange={(e) => handleFormChange(e.value, "hsnCode")}
                          placeholder="HSN Code"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.hsnCodeErr ? formData.hsnCodeErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">GST Rate</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.gstName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.gstRates}
                          value={formData.gstRate}
                          onChange={(e) => handleFormChange(e.value, "gstRate")}
                          placeholder="GST Rate"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.gstRateErr ? formData.gstRateErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Barcode</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.barcode}</p>
                  ) : (
                    <InputText
                      value={formData.barcode}
                      onChange={(e) => {
                        handleFormChange(e.target.value, "barcode");
                      }}
                      maxLength={50}
                      placeholder="Barcode"
                      className="p-w-100 e-input-common"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-6">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Product Description</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.productDescription}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.productDescription}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "productDescription")
                      }
                      maxLength={200}
                      placeholder="Product Description"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-6">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Storage Instructions / Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.storageInstructions}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.storageInstructions}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "storageInstructions")
                      }
                      maxLength={200}
                      placeholder="Storage Instructions / Remarks"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs">
                  <p className="text p-mb-1">Upload Photo</p>
                  <FilePond
                    files={formData.photo}
                    maxFileSize="5MB"
                    name="files"
                    maxFiles={1}
                    acceptedFileTypes={["image/*"]}
                    allowFileEncode={false} // set true only if you're using it intentionally
                    labelIdle={
                      'Upload Images (max size 5MB) <span className="block filepond--label-action">Browse</span>'
                    }
                    disabled={readOnly}
                    onupdatefiles={(fileItems) => {
                      handleFormChange(fileItems, "photo");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {variants.map((variant, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3 p-pb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Variant {vIdx + 1}
                </span>
                <div>
                  {readOnly && userPageAccess?.includes("Print Variant") ? (
                    <i
                      className="pi pi-print p-ml-2"
                      onClick={() => handleOpen(variant, "Print", "Variant")}
                    ></i>
                  ) : (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => removeVariant(vIdx)}
                      style={{
                        minWidth: 120,
                        borderRadius: 8,
                        fontWeight: 500,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        background: "#fff",
                        marginLeft: 8,
                      }}
                    >
                      <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                      Delete Variant
                    </Button>
                  )}
                </div>
              </div>
              <div className="p-grid p-px-4">
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Sku Id</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.skuId}</p>
                      ) : (
                        <InputText
                          value={variant.skuId}
                          disabled
                          placeholder="Variant SKU Id"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Packaging Type</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.packagingType}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              options={[
                                { label: "Fixed", value: "Fixed" },
                                { label: "Loose", value: "Loose" },
                              ]}
                              value={variant.packagingType}
                              onChange={(e) => {
                                const val = e.value;
                                setVariants((prev) => {
                                  const updated = [...prev];
                                  updated[vIdx].packagingType = val;
                                  if (val === "Loose")
                                    updated[vIdx].weightVolume = "";
                                  return updated;
                                });
                              }}
                              placeholder="Packaging Type"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {variant.packagingTypeErr
                              ? variant.packagingTypeErrText
                              : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Weight / Volume</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.weightVolume}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              disabled={variant.packagingType === "Loose"}
                              value={variant.weightVolume}
                              onChange={(e) => {
                                const val = e.target.value;
                                setVariants((prev) => {
                                  const updated = [...prev];
                                  if (val) {
                                    if (/^\d+(\.\d{0,2})?$/i.test(val)) {
                                      updated[vIdx].weightVolume = val;
                                      updated[vIdx].weightVolumeErr = false;
                                      updated[vIdx].weightVolumeErrText = "";
                                    }
                                  } else {
                                    updated[vIdx].weightVolume = "";
                                    updated[vIdx].weightVolumeErr = true;
                                    updated[vIdx].weightVolumeErrText =
                                      "This field is required";
                                  }
                                  return updated;
                                });
                              }}
                              maxLength={10}
                              placeholder="Weight / Volume"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {variant.weightVolumeErr &&
                            variant.packagingType !== "Loose"
                              ? variant.weightVolumeErrText
                              : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Units</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={variant.unit}
                              onChange={(e) =>
                                setVariants((prev) => {
                                  const updated = [...prev];
                                  updated[vIdx].unit = e.value;
                                  return updated;
                                })
                              }
                              placeholder="Units"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {variant.unitErr ? variant.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Variant Name</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.name}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={variant.name}
                              onChange={(e) => {
                                let updated = [...variants];
                                if (CommonConfig.isEmpty(e?.target?.value)) {
                                  updated[vIdx].name = "";
                                  updated[vIdx].nameErr = true;
                                  updated[vIdx].nameErrText =
                                    "This field is required";
                                } else {
                                  updated[vIdx].name = e.target.value;
                                  updated[vIdx].nameErr = false;
                                  updated[vIdx].nameErrText = "";
                                }
                                setVariants(updated);
                              }}
                              placeholder="Variant Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {variant.nameErr ? variant.nameErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Base Price / Rate</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.price}</p>
                      ) : (
                        <InputText
                          value={variant.price}
                          onChange={(e) => {
                            const val = e.target.value;
                            setVariants((prev) => {
                              const updated = [...prev];
                              if (!val || /^\d+(\.\d{0,2})?$/i.test(val)) {
                                updated[vIdx].price = val;
                              }
                              return updated;
                            });
                          }}
                          maxLength={10}
                          placeholder="Base Price / Rate"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">MRP</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.mrp}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={variant.mrp}
                              onChange={(e) => {
                                const val = e.target.value;
                                setVariants((prev) => {
                                  const updated = [...prev];
                                  if (!val || /^\d+(\.\d{0,2})?$/i.test(val)) {
                                    updated[vIdx].mrp = val;
                                  }
                                  return updated;
                                });
                              }}
                              placeholder="MRP"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          {/* <span className="error-msg" style={{ color: "red" }}>
                            {variant.mrpErr ? variant.mrpErrText : null}
                          </span> */}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.barcode}</p>
                      ) : (
                        <InputText
                          value={variant.barcode}
                          onChange={(e) => {
                            const updated = [...variants];
                            // Always convert to uppercase
                            const newPrefix = e.target.value.toUpperCase();
                            const oldPrefix = updated[vIdx].barcode;

                            updated[vIdx].barcode = newPrefix;

                            updated[vIdx].Batches = updated[vIdx].Batches.map(
                              (batch) => {
                                let suffix = batch.barcode;

                                // If old prefix exists, strip it
                                if (
                                  oldPrefix &&
                                  batch.barcode.startsWith(`${oldPrefix}-`)
                                ) {
                                  suffix = batch.barcode.slice(
                                    oldPrefix.length + 1,
                                  );
                                }

                                // If new prefix exists, prepend it
                                const newBarcode = newPrefix
                                  ? `${newPrefix}-${suffix}`
                                  : suffix;

                                return {
                                  ...batch,
                                  barcode: newBarcode,
                                };
                              },
                            );

                            setVariants(updated);
                          }}
                          maxLength={50}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-col-12 p-md-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs p-w-100">
                      <label htmlFor="chasissNo">Upload Photos</label>
                      <FilePond
                        files={variant.photos}
                        maxFileSize="5MB"
                        name="files"
                        maxFiles={3}
                        className="p-mt-1"
                        allowMultiple
                        allowFileEncode={false} // set true only if you're using it intentionally
                        labelIdle={
                          'Upload Images (max size 5MB) <span className="block filepond--label-action">Browse</span>'
                        }
                        disabled={readOnly}
                        onupdatefiles={(fileItems) => {
                          setVariants((prev) => {
                            const updated = [...prev];
                            updated[vIdx].photos = fileItems; // ✅ Correct: assign full file list
                            return updated;
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="p-sm-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Variant Description</p>
                      {readOnly ? (
                        <p className="sub-text">{variant.description}</p>
                      ) : (
                        <InputTextarea
                          className="p-w-100"
                          value={variant.description}
                          onChange={(e) => {
                            let value = e.target.value;
                            setVariants((prev) => {
                              const updated = [...prev];
                              updated[vIdx].description = value;
                              return updated;
                            });
                          }}
                          maxLength={200}
                          placeholder="Variant Description"
                        />
                      )}
                    </div>
                  </div>
                </div>
                {/* Add photo handling can be added here */}
              </div>

              {variant.Batches.map((batch, bIdx) => (
                <div
                  key={bIdx}
                  className="item-section p-mb-3 p-mx-4"
                  style={{
                    background: "#f9f9f9",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    marginBottom: "12px",
                    position: "relative",
                    boxSizing: "border-box",
                    padding: "12px 8px 8px 8px",
                  }}
                >
                  <div className="p-grid">
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <div className="p-d-flex p-ai-center">
                            <p className="text p-mb-1 p-mr-2">Batch No</p>
                            <span>
                              {readOnly &&
                              userPageAccess?.includes("Print Batch") ? (
                                <i
                                  className="pi pi-print"
                                  onClick={() =>
                                    handleOpen(
                                      { ...batch, Variant: variant },
                                      "Print",
                                      "Batch",
                                    )
                                  }
                                ></i>
                              ) : null}
                            </span>
                          </div>
                          {readOnly ? (
                            <>
                              <p className="sub-text">{batch.batchNo}</p>{" "}
                            </>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  // autoFocus
                                  value={batch.batchNo}
                                  onChange={(e) => {
                                    const updated = [...variants];
                                    if (CommonConfig.isEmpty(e.target.value)) {
                                      updated[vIdx].Batches[bIdx].batchNo = "";
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].batchNoErr = true;
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].batchNoErrText =
                                        "This field is required";
                                    } else {
                                      updated[vIdx].Batches[bIdx].batchNo =
                                        e.target.value;
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].batchNoErr = false;
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].batchNoErrText = "";
                                    }
                                    setVariants(updated);
                                  }}
                                  placeholder="Batch No"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {batch.batchNoErr ? batch.batchNoErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">MFG Date</p>
                          {readOnly ? (
                            <p className="sub-text">
                              {batch.mfgDate
                                ? moment(batch.mfgDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <>
                              <div>
                                <Calendar
                                  value={
                                    batch.mfgDate
                                      ? new Date(batch.mfgDate)
                                      : null
                                  }
                                  onChange={(e) => {
                                    const updated = [...variants];
                                    if (CommonConfig.isEmpty(e.value)) {
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].mfgDateErr = true;
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].mfgDateErrText =
                                        "This field is required";
                                    } else {
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].mfgDateErr = false;
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].mfgDateErrText = "";
                                    }
                                    updated[vIdx].Batches[bIdx].mfgDate =
                                      e.value;
                                    const expiryDate = moment(e.value)
                                      .add(
                                        parseInt(formData.lifeSpan || 0),
                                        "days",
                                      )
                                      .toDate();
                                    updated[vIdx].Batches[
                                      bIdx
                                    ].expiryDate = expiryDate;
                                    setVariants(updated);
                                  }}
                                  dateFormat="dd/mm/yy"
                                  showIcon={false}
                                  placeholder="Select MFG Date"
                                  className="p-w-100"
                                  disabled={readOnly}
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {batch.mfgDateErr ? batch.mfgDateErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Expiry Date</p>
                          {readOnly ? (
                            <p className="sub-text">
                              {batch.expiryDate
                                ? moment(batch.expiryDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <Calendar
                              value={
                                batch.expiryDate
                                  ? new Date(batch.expiryDate)
                                  : null
                              }
                              disabled
                              dateFormat="dd/mm/yy"
                              showIcon={false}
                              placeholder="Select Expiry Date"
                              className="p-w-100"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">MRP</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.mrp}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={batch.mrp}
                                  onChange={(e) => {
                                    const updated = [...variants];

                                    if (CommonConfig.isEmpty(e.target.value)) {
                                      updated[vIdx].Batches[bIdx].mrp = "";
                                      updated[vIdx].Batches[bIdx].mrpErr = true;
                                      updated[vIdx].Batches[bIdx].mrpErrText =
                                        "This field is required";
                                    } else {
                                      if (
                                        /^\d+(\.\d{0,2})?$/i.test(
                                          e.target.value,
                                        )
                                      ) {
                                        updated[vIdx].Batches[bIdx].mrp =
                                          e.target.value;
                                        updated[vIdx].Batches[
                                          bIdx
                                        ].mrpErr = false;
                                        updated[vIdx].Batches[bIdx].mrpErrText =
                                          "";
                                      }
                                    }
                                    setVariants(updated);
                                  }}
                                  placeholder="MRP"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {batch.mrpErr ? batch.mrpErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Rate</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.rate}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={batch.rate}
                                  onChange={(e) => {
                                    const updated = [...variants];

                                    if (CommonConfig.isEmpty(e.target.value)) {
                                      updated[vIdx].Batches[bIdx].rate = "";
                                      updated[vIdx].Batches[
                                        bIdx
                                      ].rateErr = true;
                                      updated[vIdx].Batches[bIdx].rateErrText =
                                        "This field is required";
                                    } else {
                                      if (
                                        /^\d+(\.\d{0,2})?$/i.test(
                                          e.target.value,
                                        )
                                      ) {
                                        updated[vIdx].Batches[bIdx].rate =
                                          e.target.value;
                                        updated[vIdx].Batches[
                                          bIdx
                                        ].rateErr = false;
                                        updated[vIdx].Batches[
                                          bIdx
                                        ].rateErrText = "";
                                      }
                                    }
                                    setVariants(updated);
                                  }}
                                  placeholder="Rate"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {batch.rateErr ? batch.rateErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Quantity Produced</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.qtyProduced}</p>
                          ) : (
                            <InputText
                              value={batch.qtyProduced}
                              onChange={(e) => {
                                const updated = [...variants];
                                if (/^\d+(\.\d{0,2})?$/i.test(e.target.value)) {
                                  updated[vIdx].Batches[bIdx].qtyProduced =
                                    e.target.value;
                                }
                                setVariants(updated);
                              }}
                              placeholder="Quantity Produced"
                              className="p-w-100 e-input-common"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Quantity Remaining</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.qtyRemaining}</p>
                          ) : (
                            <InputText
                              value={batch.qtyRemaining}
                              onChange={(e) => {
                                const updated = [...variants];
                                if (/^\d+(\.\d{0,2})?$/i.test(e.target.value)) {
                                  updated[vIdx].Batches[bIdx].qtyRemaining =
                                    e.target.value;
                                }
                                setVariants(updated);
                              }}
                              placeholder="Quantity Remaining"
                              className="p-w-100 e-input-common"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Batch Status</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.status}</p>
                          ) : (
                            <Dropdown
                              options={[
                                { label: "Expired", value: "Expired" },
                                { label: "Active", value: "Active" },
                                { label: "Inactive", value: "Inactive" },
                              ]}
                              value={batch.status}
                              onChange={(e) => {
                                const updated = [...variants];
                                updated[vIdx].Batches[bIdx].status = e.value;
                                setVariants(updated);
                              }}
                              placeholder="Batch Status"
                              className="p-w-100 e-input-common"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Barcode</p>
                          {readOnly ? (
                            <p className="sub-text">{batch.barcode}</p>
                          ) : (
                            <InputText
                              value={batch.barcode}
                              onChange={(e) => {
                                const updated = [...variants];
                                const prefix = updated[vIdx].barcode
                                  ? `${updated[vIdx].barcode}-`
                                  : "";

                                // Always uppercase the input
                                const inputValue = e.target.value.toUpperCase();

                                // Remove prefix if user is typing full value
                                const suffix = inputValue.startsWith(prefix)
                                  ? inputValue.slice(prefix.length)
                                  : inputValue;

                                // Re-append prefix to clean suffix
                                const finalValue = prefix + suffix;

                                updated[vIdx].Batches[
                                  bIdx
                                ].barcode = finalValue;
                                setVariants(updated);
                              }}
                              maxLength={50}
                              placeholder="Barcode"
                              className="p-w-100 e-input-common"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {!readOnly && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => removeBatch(vIdx, bIdx)}
                      style={{
                        minWidth: 120,
                        borderRadius: 8,
                        fontWeight: 500,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        background: "#fff",
                        marginTop: 8,
                      }}
                    >
                      <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                      Delete Batch
                    </Button>
                  )}
                </div>
              ))}

              {!readOnly && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => addBatch(vIdx)}
                  className="add-item-btn p-mx-4"
                  style={{ marginTop: 8 }}
                >
                  <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add
                  Batch
                </Button>
              )}
            </div>
          ))}
          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addVariant}
              className="add-item-btn"
              style={{ marginTop: 8 }}
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add
              Variant
            </Button>
          )}
        </div>
      </div>
      <div>
        <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
          <button
            className="secondary-btn"
            onClick={() => {
              props.history.push("/admin/details-variant-master");
            }}
          >
            Cancel
          </button>
          {readOnly ? null : (
            <Button
              className="primary-btn color-white p-ml-1"
              onClick={AddUpdateDetailsVariant}
              disabled={loading}
            >
              Submit
            </Button>
          )}
        </div>
      </div>

      <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="Product"
        onAfterPrint={() => {
          setPrintData({});
        }}
      />

      <div className="p-d-none">
        {/* <div className="im-p-dp details-variant-print" ref={componentRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: templateHtml,
            }}
          />
        </div> */}
      </div>

      <PrintDialog
        open={showPrintDialog}
        onClose={() => setShowPrintDialog(false)}
        templateHtml={templateHtml}
        onPrint={(copies) => zebraWidgetRef.current.onPrint(copies)}
      />

      <ZebraPrinterWidget
        ref={zebraWidgetRef}
        templateData={printData1}
        dpi={203}
      />
    </div>
  );
};

export default AddDetailsVariantMaster;
